import { useCreatorStates } from '@/modules/creators/hooks/use-creator-states.tsx'
import { CreatorStatusIndicator } from '@/modules/creators/ui/CreatorStatusIndicator.tsx'
import { getCreatorProxyStatusByCreatorId } from '@/modules/creators/utils.ts'

export const LiveCreatorStatusIndicator = ({
  creatorId,
}: {
  creatorId: number
}) => {
  const { creatorStates, creatorStatesLoading } = useCreatorStates()

  if (creatorStatesLoading || !creatorStates) {
    return null
  }

  return (
    <div className="absolute -bottom-1.5 -right-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-card">
      <CreatorStatusIndicator
        status={getCreatorProxyStatusByCreatorId(creatorStates, creatorId)}
      />
    </div>
  )
}
